'use client';

import { useSearchParams } from 'next/navigation';

import {
  AuthParamReview,
  AuthSearchParam,
} from '@sola/schema/dotcom/auth/routes.ts';
import { useAccountSettings } from '@sola/supporter-sdk/hooks/settings.ts';

export const useAccountSettingsLogic = () => {
  const accountSettings = useAccountSettings();
  const searchParams = useSearchParams();
  const reviewAccountInfo =
    searchParams.get(AuthSearchParam.Review) === AuthParamReview.AccountInfo;
  const nonPrimaryContacts =
    accountSettings.contacts?.filter((contact) => !contact.isPrimary) ?? [];

  return {
    ...accountSettings,
    reviewAccountInfo,
    nonPrimaryContacts,
  };
};
